export const INPROGRESS = "INPROGRESS";
export const COMPLETE = "COMPLETE";
export const IS_AUTHENTICATED = "IS_AUTHENTICATED";
export const ERROR = "ERROR";
export const LOGOUT = "LOGOUT";
export const SET_CHARGES = "SET_CHARGES";
export const SUCCESS = "SUCCESS";
export const PAYMENT_SUCESS = "PAYMENT_SUCESS";
export const USER_PAYMENT_DETAIL = "USER_PAYMENT_DETAIL";
